import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
//import { Observable } from "rxjs/internal/Observable";
import { Observable } from "rxjs";
import { BaseDataService } from "../base-data-service";
import { AppConfigService } from "@tmhcc/global-services";
import { map, catchError } from "rxjs/operators";
import { 
  WtUpdateQuoteResponse
} from "../../models/classes/weather-quote.model";
import {      
  WtUpdateQuoteRequest
} from "libs/data-service/def/weather-quote";

@Injectable()
export class WeatherQuoteService extends BaseDataService { 
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService    
  ) {
    super(http, configService);
  } 

  updateQuote(payload:WtUpdateQuoteRequest) : Observable<WtUpdateQuoteResponse>
  {  
    let baseURL = this.weatherServiceBaseUrl;   
      let serviceApiKey = this.weatherServiceAPIKey;      
      const url = `${baseURL}quote`;   
      return this.postv1<WtUpdateQuoteRequest>(url, { body: payload },serviceApiKey).pipe(
        map(data => this.mapToUpdateQuoteResponse(data)) ,
        catchError(this.handleError)     
      );
  }
  mapToUpdateQuoteResponse(data:any): WtUpdateQuoteResponse {    
    let quoteResponse = new WtUpdateQuoteResponse();
    if(!data) return null;     
    quoteResponse = data;     
    return quoteResponse;
  }  

  mapSaveSubjectivity(data: any) {   
    return data.quoteId;
  }

}
